/* eslint-disable */

import { EVENTS } from '../../../../app/constants/events';

xplenty.directive('schemaImporterTable', [
  '$timeout',
  '$translate',
  '$rootScope',

  function ($timeout, $translate, $rootScope) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./schema-importer-table.html'),

      replace: true,

      scope: {
        id: '=',
        fields: '=ngModel',
        valid: '=?',
        errors: '=?',
        options: '=',
      },

      link(scope, element) {
        scope.dataTypeOptions = [
          { value: 'string', text: 'variables-editor-row.selects.data_type.options.string', translate: true },
          !scope.options.allowToChangeDataTypeToStringBinaryOnly
            ? { value: 'int', text: 'variables-editor-row.selects.data_type.options.int', translate: true }
            : null,
          !scope.options.allowToChangeDataTypeToStringBinaryOnly
            ? { value: 'long', text: 'variables-editor-row.selects.data_type.options.long', translate: true }
            : null,
          !scope.options.allowToChangeDataTypeToStringBinaryOnly
            ? { value: 'float', text: 'variables-editor-row.selects.data_type.options.float', translate: true }
            : null,
          !scope.options.allowToChangeDataTypeToStringBinaryOnly
            ? { value: 'double', text: 'variables-editor-row.selects.data_type.options.double', translate: true }
            : null,
          { value: 'binary', text: 'variables-editor-row.selects.data_type.options.binary', translate: true },
          !scope.options.allowToChangeDataTypeToStringBinaryOnly
            ? { value: 'boolean', text: 'variables-editor-row.selects.data_type.options.boolean', translate: true }
            : null,
          !scope.options.allowToChangeDataTypeToStringBinaryOnly
            ? { value: 'datetime', text: 'variables-editor-row.selects.data_type.options.datetime', translate: true }
            : null,
          scope.options.allowComplexDataTypes
            ? { value: 'json', text: 'variables-editor-row.selects.data_type.options.json', translate: true }
            : null,
          scope.options.allowComplexDataTypes
            ? { value: 'array', text: 'variables-editor-row.selects.data_type.options.array', translate: true }
            : null,
        ].filter(Boolean);

        scope.onDataTypeChange = (dataType, field) => {
          field.data_type = dataType;
        };

        // SORTING
        // -------------------------------------
        let startSortIndex = 0;
        let endSortIndex = 0;
        let sorting = false;
        const $tbody = element.find('tbody');

        const removeAddToIndex = function () {
          angular.element('.add-to-index-button').remove();
        };

        const showAddToIndex = function () {
          removeAddToIndex();
          const $addToIndex = angular.element(
            '<tr class="add-to-index-button"><td colspan="5"><i class="fa fa-plus"></i></td></tr>',
          );
          if (!sorting) {
            const $tr = angular.element(this);
            const index = $tr.index();
            $tbody.find(`tr:nth-child(${index + 1})`).before($addToIndex);
            const $addToIndexHandler = $addToIndex.find('i');
            const paginationIndex = scope.pagination.itemsPerPage * (scope.pagination.current - 1) + index;
            if (scope.fields[paginationIndex].disableSortable) {
              $addToIndex.remove();
              return;
            }
            $addToIndexHandler.on('click', function () {
              $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_ADD_NEW_FIELD, {
                index: paginationIndex,
              });
              $addToIndex.remove();
            });
          }
        };

        const initAddToIndex = function () {
          if (scope.options.allowToAddFieldBetweenFields) {
            $timeout(function () {
              $tbody
                .find('tr:not(.add-to-index-button)')
                .off('mouseenter', showAddToIndex)
                .on('mouseenter', showAddToIndex);
              $tbody.off('mouseleave', removeAddToIndex).on('mouseleave', removeAddToIndex);
            });
          }
        };

        const changeItemPosition = function (event, fromIndex, toIndex) {
          scope.fields.splice(toIndex, 0, scope.fields.splice(fromIndex, 1)[0]);
          scope.$apply();
        };

        const getPaginagionIndex = function (index) {
          return (scope.pagination.current - 1) * scope.pagination.itemsPerPage + index;
        };

        function fixWidthHelper(event, ui) {
          ui.children().each(function () {
            const $tableCell = $(this);
            if ($tableCell.hasClass('field-name')) {
              //  || $tableCell.hasClass('field-alias')
              $tableCell.width($tableCell.width() + 2);
            } else {
              $tableCell.width($tableCell.width());
            }
          });
          return ui;
        }

        const startSortHandle = function (event, ui) {
          removeAddToIndex();
          sorting = true;
          startSortIndex = getPaginagionIndex(ui.item.index());
          element.find('.add-to-index-button').hide();
        };

        const endSortHandle = function (event, ui) {
          endSortIndex = getPaginagionIndex(ui.item.index());
          changeItemPosition(event, startSortIndex, endSortIndex);
          ui.item.find('td,th').each(function () {
            $(this).removeAttr('style');
          });
          $timeout(scope.initSortable);
          sorting = false;
        };

        scope.initSortable = function () {
          $timeout(function () {
            const $sortable = element.find('.tbody-sortable');
            $sortable
              .sortable({
                handle: '.field-move',
                cancel: '',
                items: '.selected-list-item:not(.field-move-disable)',
                axis: 'y',
                cursor: 'move',
                containment: 'parent',
                placeholder: 'selected-list-item-highlight',
                tolerance: 'pointer',
                start: startSortHandle,
                update: endSortHandle,
                helper: fixWidthHelper,
              })
              .disableSelection();
            scope.$apply();
          });
        };

        const DEFAULT_TAB_NAME = 'Schema';
        let currentTabName = DEFAULT_TAB_NAME;

        const getTabIndex = function (tabName) {
          let tabIndex = -1;
          _.each(scope.tabs, function (tab, index) {
            if (tab.name === tabName) tabIndex = index;
          });
          return tabIndex;
        };

        scope.$watch(
          'fields',
          function (newFields) {
            let hasEditableFields = false;
            _.each(newFields, function (field) {
              if (field.editable) {
                hasEditableFields = true;
              }
            });
            scope.options.hasEditableFields = hasEditableFields;

            if (newFields.length === 0) {
              scope.selectedTabFields = [];
              scope.tabs = [];
              $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_TAB_SELECTED);
              return;
            }

            scope.tabs = _.chain(newFields)
              .groupBy('category')
              .map(function (fields, name) {
                return {
                  name: name === 'undefined' ? 'All' : name,
                  fields,
                };
              })
              .value();

            const schemaIndex = getTabIndex(currentTabName);

            if (schemaIndex === -1) {
              currentTabName = 'All';
            }

            scope.selectTab(scope.tabs[getTabIndex(currentTabName)]);

            if (scope.options.allowToSortSelectedFields) $timeout(scope.initSortable);
          },
          true,
        );

        scope.$watch('options.allowToSortSelectedFields', function (allowToSortSelectedFields) {
          if (allowToSortSelectedFields) $timeout(scope.initSortable);
        });

        scope.selectTab = function (selectedTab) {
          if (!selectedTab) selectedTab = scope.tabs[0];
          _.each(scope.tabs, function (tab) {
            tab.active = false;
          });
          selectedTab.active = true;
          currentTabName = selectedTab.name;
          scope.selectedTabFields = selectedTab.fields;
          $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_TAB_SELECTED);
        };

        scope.selectTabAndClearSearch = function (selectedTab) {
          scope.selectTab(selectedTab);
          scope.clearSearch();
        };

        scope.pageChanged = function () {
          $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_TAB_SELECTED);
        };

        scope.removeAddToIndex = removeAddToIndex;
      },

      controller: [
        '$scope',
        '$sce',
        function ($scope, $sce) {
          const defaultOptions = {
            automaticallyDetectAvailableFields: false,
            autoSelectAllAvailableFields: false, // autoSelectAll
            allowToSortSelectedFields: false, // sortable
            allowSelectAllAvailableFields: false, // autoSelect
            allowComplexDataTypes: false, // complexDataType
            showFieldNumber: false, // index
            sourceDesginatorName: 'Column',
            showSourceDesignatorInSelectedFields: false,
            allowToAddFieldBetweenFields: false, // addToIndex
            allowToAddFieldsAtTheEnd: false, // addToEnd
            allowToRemoveSelectedFields: false, // remove
            allowToEditAlias: false, // aliasEditable
            allowRemoveAll: false,
            allowToChangeDataType: false, // typeEditable,
            allowToChangeDataTypeToStringBinaryOnly: false, // typeStringBinaryOnly

            nameEditable: false,
            editable: false,
            preDefined: false,
            selectAll: false,
            hasEditableFields: false,
            showAlias: $scope.id === 'selected-fields',
          };

          $scope.pagination = {
            itemsPerPage: 15,
            current: 1,
          };

          $scope.options = _.merge(defaultOptions, $scope.options);

          $scope.emptyText = 'The list is empty.';
          $scope.fieldSearch = {
            text: '',
          };

          $scope.selectedTabFields = [];
          $scope.tabs = [];

          $scope.getId = function () {
            return $scope.id;
          };

          $scope.validate = function () {};

          $scope.isFieldValid = function (field) {
            const valid = /^[a-zA-Z]+[\w]*(::[a-zA-Z]+)?[\w]*$/.test(field.name);
            field.invalid = !valid;
            return valid;
          };

          $scope.addField = function (field, index) {
            switch ($scope.id) {
              case 'available-fields':
                $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_ADD_FIELD, field);
                break;
              case 'selected-fields':
                var paginationIndex = $scope.pagination.itemsPerPage * ($scope.pagination.current - 1) + index + 1;
                $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_ADD_NEW_FIELD, {
                  index: paginationIndex,
                });
                break;
            }
          };

          $scope.search = function (field) {};

          $scope.startEditField = function () {
            const $input = angular.element(event.target);
            $input.tooltip('destroy');
          };

          $scope.setFieldName = function (field, event) {
            const name = event.target.value;
            const existingField = _.find($scope.fields, { name });
            const isSameField = _.isEqual(field, existingField);

            if (!existingField && !isSameField && $scope.isFieldValid({ name })) {
              field.name = name;
              field.invalid = false;
            } else if (existingField && !isSameField) {
              var $input = angular.element(event.target);
              $input.tooltip({ placement: 'top', title: 'Field name must be unique' });
              $input.tooltip('show');
              field.invalid = true;
            } else {
              var $input = angular.element(event.target);
              $input.tooltip({ placement: 'top', title: 'Field name contains illegal keyword or characters' });
              $input.tooltip('show');
              field.invalid = true;
            }
          };

          $scope.addToEnd = function () {
            const field = {
              name: '',
              alias: '',
              editable: true,
            };
            $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_ADD_NEW_FIELD, field);
            $scope.pagination.current = Math.ceil($scope.fields.length / $scope.pagination.itemsPerPage);
          };

          $scope.addBetween = function (index) {
            const paginationIndex = $scope.pagination.itemsPerPage * ($scope.pagination.current - 1) + ++index;
            $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_ADD_NEW_FIELD, {
              index: paginationIndex,
            });
          };

          $scope.removeField = function (field) {
            $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_REMOVE_FIELD, field);
            $scope.removeAddToIndex();
          };

          $scope.clearSearch = function () {
            $scope.fieldSearch.text = '';
            $scope.$parent.setHeight();
          };

          $scope.highlight = function (text, search) {
            if (!search) {
              return $sce.trustAsHtml(text);
            }
            return $sce.trustAsHtml(text.replace(new RegExp(search, 'gi'), '<span class="highlighted">$&</span>'));
          };
        },
      ],
    };
  },
]);
